
import { defineComponent } from "vue";
import QInput from 'quasar/src/components/input/QInput.js';;

import { mapState, mapWritableState, mapActions } from "pinia";
import { useBillStore, TypePaymentMethod } from "@/stores/BillStore";

import "vue-tel-input/dist/vue-tel-input.css";
import PayBtn from "./PayBtn.vue";

import { notify } from "@/plugins/notify/notify";

export default defineComponent({
  name: "LayoutDefault",
  computed: {
    ...mapState(useBillStore, ["checkData", "waitPayment", "billData"]),
    ...mapWritableState(useBillStore, ["userData"]),
    negativeColor() {
      return window.onlBillTheme?.primary || "#C10015";
    },
  },
  methods: {
    ...mapActions(useBillStore, ["payBill"]),
    validate(paymentMethod: TypePaymentMethod) {
      (this.$refs["fio"] as typeof QInput).validate();
      (this.$refs["email"] as typeof QInput).validate();
      this.phoneBlurred = true;
      if (
        !(this.$refs["fio"] as typeof QInput).hasError &&
        this.phoneValid &&
        !(this.$refs["email"] as typeof QInput).hasError
      ) {
        this.payBill(paymentMethod);
      } else {
        notify({
          type: "negative",
          message: "Заполните все поля",
          icon: "warning",
        });
      }
    },
  },
  data: () => ({ phoneValid: true, phoneBlurred: false }),
  components: { PayBtn },
});
